import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const KeySellingPointsBarItem = t0 => {
  const $ = _c(8);
  const {
    icon,
    children,
    onClick
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="text-gray flex mr-[11px] group-focus:text-brand group-hover:text-brand ml-6">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span className="leading-[0] text-gray group-focus:text-brand group-hover:text-brand">{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClick || $[5] !== t1 || $[6] !== t2) {
    t3 = <button type="button" className="group text-base items-center bg-transparent border-0 flex flex-row flex-1 px-2 py-0 text-left whitespace-nowrap lg:mx-0 lg:my-4 first:max-[1023px]:pl-4 last:max-[1023px]:pr-4 hover:cursor-pointer" onClick={onClick}>{t1}{t2}</button>;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
KeySellingPointsBarItem.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func
};
export default KeySellingPointsBarItem;